<div class="graph">
  @if (isRequesting) {
    <span class="ui-loading" [model]="{isLoading: true}"></span>
  }
  @if (noSelectedTag) {
    <div
      class="noTags">
      <div class="noTags-Title" [translate]="'stations.graph.message.no_selected_tag_title'"></div>
      <div [translate]="'stations.graph.message.no_selected_tag_message'"></div>
    </div>
  } @else {
    @if (displayNoData) {
      <div class="noTags">
        <div class="noTags-Title" [translate]="'stations.graph.message.no_data_title'"></div>
        <div [translate]="'stations.graph.message.no_data_message'"></div>
      </div>
    }
    @if (!displayNoData) {
      <div echarts [options]="options" (chartInit)="onInitCharts($event)" (chartDataZoom)="onZoom($event)" (chartRestore)="onRestore()"class="graph-wrap"></div>
    }
    @if (statsModeEnable) {
      <div class="stats-container">
        <div class="ui-table" [tableInput]='table'></div>
      </div>
    }
  }
</div>